module.exports = __webpack_public_path__ + "static/img/88109S_2_3_C_20200315_LC.dc51c19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/88109S_2_3_C_20200315_LC.png
// module id = r//S
// module chunks = 0